<template>
<div>
  <section :class="className">
    <div class="flex justify-between items-center mb-30">
      <h2 class="fs-28" v-html='title'></h2>
      <client-only>
        <router-link v-if='$device.isDesktopOrTablet && !isEmpty(url)' :class="buttonClass" :to="url" h="view-all-trip" @click="setGallerySource">
          See All Trips
        </router-link>
      </client-only>
    </div>
    <div class="scroll-wrapper">
      <div class="scroll-container">
        <div class="scroll-items-section" style='width: 1220px'>
          <div class="flex">
            <div
              :class="['item mb-20', index === listTrips.items.length - 1  ? 'mr-0' : 'mr-20']"
              style="width: 25%; min-width: 290px"
              v-for="(item, index) in listTrips.items"
              :key="index"
            >
              <TripCard :cardData="item" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <client-only>
    <div class='flex justify-center pt-30' v-if='$device.isMobile'>
      <router-link :class="buttonClass" :to="url" v-if="!isEmpty(url)" h="view-all-trip" @click="setGallerySource">
        See All Trips
      </router-link>
    </div>
  </client-only>
</div>
</template>

<script setup>
  import TripCard from '~/components/elements/TripCard/TripCard'
  import { isEmpty } from '~/helper'
  import { useHeapStore } from '~/store/pinia/heap'

  const props = defineProps({
    listTrips: { type: [Object, Array] },
    title: { type: String },
    url: { type: Object, default: () => {} },
    className: { type: String },
    heapSource: { type: String, default: 'suggestion' },
  })

  const buttonClass = 'button-border button-gray py-12 px-20 fs-14 lh-16 br-14 fw-700'
  const heapStore = useHeapStore()

  const setGallerySource = async () => {
    await heapStore.changeGalleryHeap(props.heapSource)
  }
</script>

<style lang="scss" scoped>
@include scroll-section();
</style>
